import React, { useCallback, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showLoader, hideLoader } from '../../../../actionCreators/returnExchange';
import { clearState } from '../../../../actionCreators/order';
import { getOrders } from '../../../../actionCreators/myAccount';
import { getOrder } from '../../../../actionCreators/order';
import * as successApiCall from '../../../../actionCreators/success';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import LKModal from '../../Modal/Modal';
import PrescriptionsOptions from '../../Success/PrescriptionsOptions';
import PrescriptionsEnterManual from '../../Success/PrescriptionsEnterManual';
import PrescriptionsEmail from '../../Success/PrescriptionsEmail';
import PrescriptionsCall from '../../Success/PrescriptionsCall';
import SuccessModalHeader from '../../Success/SuccessModalHeader';
import SelectPrescriptions from '../../Success/SelectPrescriptions';
import UploadPrescription from '../../Product/ContactLenses/UploadPrescription';
import ProductDetail from '../../../containers/MyAccount/OrderReturnNew/ProductDetail';
// import ArrowBack from '../../../../../static/assets/svg/mui-icons/ArrowBack.svg';
import './UpdatePower.scss';
import AddPD from '../../Success/AddPD';

function updateOrder(getOrders, showPowerOptionsFn, match, getOrder) {
  const pageNumber = sessionStorageHelper.getItem('orderActivePage') || 0;
  const pager = pageNumber <= 1 ? 0 : pageNumber - 1;
  getOrders(pager, 10);
  if (match?.params?.id) {
    getOrder({ orderId: match.params.id, dontInitSession: true, isMyAcct: true });
  }
  showPowerOptionsFn();
}

function UpdatePower(props) {
  const {
    dataLocale,
    localeInfo,
    loading,
    loginStatus,
    item,
    orderData,
    successApiCall,
    setMethodState,
    powerSubmitFail,
    powerSubmitted,
    savedPrescription,
    getOrders,
    showPowerOptionsFn,
    clearState,
    match,
    getOrder,
    setMethod,
    isExchangeFlow,
    setOpen,
    setSelectedPower,
    showLoader,
    hideLoader,
    cartData,
    redisCommonData,
    userInfo,
    powerSubmittedItemId,
    history,
  } = props;
  const { ENTER_PRESCRIPTION_MANUALLY, SAVED_POWERS, UPLOAD_PRESCRIPTION } = dataLocale;
  const orderDetail = { result: orderData };
  const [showPrescModal, showModalFunc] = useState({});
  const [showHideBlock, showHideBlockFunc] = useState(false);
  const [uploadStatus, uploadStatusInfoFunc] = useState({});
  const [isPowerSubmitFailed, powerSubmitFailFunc] = useState('');
  const [filteredPrescriptionList, showSavedPrescFunc] = useState({});
  const [selectedProduct, setSelectedProduct] = useState({});
  const [showPdOption, setShowPdOption] = useState(false);
  const updateOrderFn = useCallback(
    updateOrder.bind(null, getOrders, showPowerOptionsFn, match, getOrder),
    []
  );

  const handlePowerBlock = useCallback(show => {
    showHideBlockFunc(show);
  }, []);

  const showPowerModal = useCallback(type => {
    if (type) {
      showModalFunc({ showModal: true, type });
      document.body.classList.add('no-scroll-account');
      document.getElementsByTagName('html')[0].classList.add('no-scroll-account');
    } else {
      showModalFunc({ showModal: false });
      document.body.classList.remove('no-scroll-account');
      document.getElementsByTagName('html')[0].classList.remove('no-scroll-account');
      showHideBlockFunc(false);
      powerSubmitFailFunc(false);
      successApiCall.enterDataFunc({
        left: { sph: '', cyl: '', axis: '', ap: '', pd: '' },
        right: { sph: '', cyl: '', axis: '', ap: '', pd: '' },
      });
      successApiCall.enterErrorFunc('');
    }
  }, []);

  useEffect(() => {
    if (!savedPrescription && !loading) {
      successApiCall.getSavedPrescription();
    } else if (savedPrescription?.result && Object.keys(filteredPrescriptionList).length === 0) {
      const presObj = {};
      for (let i = 0, len = savedPrescription.result.length; i < len; i++) {
        const item = savedPrescription.result;
        if (!presObj[item[i].powerType]) {
          presObj[item[i].powerType] = [];
        }
        presObj[item[i].powerType].push(item[i]);
      }
      showSavedPrescFunc(presObj);
    }
    if (powerSubmitFail) {
      powerSubmitFailFunc(powerSubmitFail);
    } else if (powerSubmitted && !isExchangeFlow) {
      const selectedProductData = powerSubmitted?.result?.items.find(
        item => item?.id == powerSubmittedItemId
      );
      const showPd = selectedProductData?.prescriptionView?.showPd;
      setSelectedProduct(selectedProductData);
      setShowPdOption(showPd);

      clearState({ orderDetails: null });

      if (!showPd) {
        updateOrderFn();
        showPowerModal();
      }
    }
  }, [powerSubmitted, powerSubmitFail, savedPrescription]);

  const fileUploadSuccess = useCallback((success, uploadSuccess) => {
    let uploadImageData = '';
    if (uploadSuccess.result.code === 200) {
      uploadImageData = {
        imageFileName: uploadSuccess.result.filename,
        powerType: item.lensType === 'POWER' ? 'SUNGLASSES' : item.lensType,
        userName: orderData.shippingAddress.firstName + orderData.shippingAddress.lastName,
        left: {},
        right: {},
      };
      uploadStatusInfoFunc({ uploadSuccess: uploadSuccess.result.message, uploadError: '' });
      if (isExchangeFlow) {
        setSelectedPower(uploadSuccess.result);
        setOpen(false);
        const method = sessionStorageHelper.getItem('powerMethod');
        setMethodState(method);
        sessionStorageHelper.setItem('exchangePowerDetails', {
          itemId: item.id,
          powerData: uploadImageData,
          email: orderData.customerEmail,
          orderId: orderData.id,
        });
      } else {
        successApiCall.submitPowers(
          item.id,
          uploadImageData,
          orderData.customerEmail,
          orderData.id
        );
      }
    } else if (uploadSuccess.result.error) {
      uploadStatusInfoFunc({ uploadSuccess: '', uploadError: uploadSuccess.result.error });
    }
  }, []);

  const submitPower = useCallback((id, data, email) => {
    if (isExchangeFlow) {
      // Show loader for 1 second
      showLoader();
      setTimeout(() => {
        setOpen(false);
        hideLoader();
        const method = sessionStorageHelper.getItem('powerMethod');
        setMethodState(method);
        sessionStorageHelper.setItem('exchangePowerDetails', {
          itemId: id,
          powerData: data,
          email,
          orderId: orderData.id,
        });
      }, 1000);
    } else {
      successApiCall.submitPowers(id, data, email, orderData.id);
    }
  }, []);

  const renderPrescriptionsOptions = () => {
    return {
      enterPrescription: (
        <PrescriptionsEnterManual
          activeProductData={item}
          handlePowerBlock={handlePowerBlock}
          hideHandler={showPowerModal}
          isPowerSubmitFailed={isPowerSubmitFailed}
          localeInfo={localeInfo}
          setMethodState={setMethodState}
          showHideBlock={showHideBlock}
          successApiCall={successApiCall}
          {...props}
          cartData={cartData}
          history={history}
          orderData={orderData}
          productsDetail={orderDetail}
          selectedProduct={selectedProduct}
          setSelectedPower={setSelectedPower}
          showPDOption={showPdOption}
          submitPowers={submitPower}
          updateOrderFn={updateOrderFn}
          userInfo={userInfo}
        />
      ),
      savedPrescription: (
        <SelectPrescriptions
          activeProductData={item}
          filteredPrescription={filteredPrescriptionList}
          hideHandler={showPowerModal}
          isPowerSubmitFailed={isPowerSubmitFailed}
          productsDetail={orderDetail}
          setMethodState={setMethodState}
          submitPowers={submitPower}
          {...props}
          history={history}
          orderData={orderData}
          selectedProduct={selectedProduct}
          setSelectedPower={setSelectedPower}
          showPDOption={showPdOption}
          updateOrderFn={updateOrderFn}
          userInfo={userInfo}
        />
      ),
      uploadPrescription: (
        <div className="upload-modal">
          {item && (
            <SuccessModalHeader
              activeProductData={item}
              dataLocale={dataLocale}
              hideHandler={showPdOption ? updateOrderFn : showPowerModal}
              isExchangeFlow={isExchangeFlow}
              orderData={orderData}
            />
          )}
          {showPdOption ? (
            <AddPD
              dataLocale={dataLocale}
              hideHandler={showPowerModal}
              history={history}
              order={orderData}
              selectedProduct={selectedProduct}
              updateOrder={updateOrderFn}
              userInfo={userInfo}
            />
          ) : (
            <UploadPrescription
              fileUploadSuccess={fileUploadSuccess}
              imagePreviewUrl=""
              isPowerSubmitFailed={isPowerSubmitFailed}
              setSelectedPower={setSelectedPower}
              submitPowers={submitPower}
              uploadError={uploadStatus.uploadError}
              uploadSuccess={uploadStatus.uploadSuccess}
            />
          )}
        </div>
      ),
      callBack: (
        <PrescriptionsCall
          activeProductData={item}
          hideHandler={showPowerModal}
          isExchangeFlow={isExchangeFlow}
          productsDetail={orderDetail}
          submitPower={submitPower}
          {...props}
        />
      ),
      successEmail: (
        <PrescriptionsEmail
          activeProductData={item}
          dataLocale={dataLocale}
          hideHandler={showPowerModal}
          isExchangeFlow={isExchangeFlow}
          productsDetail={orderDetail}
          submitPower={submitPower}
        />
      ),
    }[showPrescModal.type];
  };

  const prescriptionModalHeaderName = () => {
    return {
      enterPrescription: ENTER_PRESCRIPTION_MANUALLY,
      savedPrescription: SAVED_POWERS,
      uploadPrescription: UPLOAD_PRESCRIPTION,
    }[showPrescModal.type];
  };

  return (
    <>
      {isExchangeFlow && !showPrescModal.showModal && (
        <ProductDetail cartData={cartData} currentItem={item} isExchangeFlow={isExchangeFlow} />
      )}
      {isExchangeFlow && showPrescModal.showModal && (
        <div className="padding-t15 padding-b15 display-flex align-items-center fs20 fw500">
          <img
            alt="arrow-back"
            className="margin-l20 margin-r20"
            src="https://static.lenskart.com/media/desktop/img/myorder/ArrowBack.svg"
            onClick={() => {
              showModalFunc({ showModal: false });
            }}
          />
          {prescriptionModalHeaderName()}
        </div>
      )}
      <div
        className={`uploadPower ${
          isExchangeFlow ? 'exchangeUploadPower' : 'padding-r10 padding-l10 padding-b5'
        }`}
      >
        {((isExchangeFlow && !showPrescModal.showModal) || !isExchangeFlow) && (
          <PrescriptionsOptions
            activeProductData={item}
            dataLocale={dataLocale}
            filteredPrescription={filteredPrescriptionList}
            isExchangeFlow={isExchangeFlow}
            localeInfo={localeInfo}
            login={loginStatus}
            openPopUp={showPowerModal}
            redisCommonData={redisCommonData}
            setMethod={setMethod}
            setOpen={setOpen}
            setSelectedPower={setSelectedPower}
          />
        )}
        {!isExchangeFlow && showPrescModal.showModal && (
          <LKModal
            backdrop
            keyboard
            dialogClassName="myOrder-powerUpload"
            hideHandler={showPowerModal}
            showModal={showPrescModal.showModal}
            size="lg"
          >
            {renderPrescriptionsOptions()}
          </LKModal>
        )}
        {isExchangeFlow && showPrescModal.showModal && (
          <div className="myOrder-powerUpload" style={{ width: '100%' }}>
            <div className="modal-content" role="document">
              <div className="modal-body">{renderPrescriptionsOptions()}</div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

const mapStateToProps = state => {
  const cartData = state.cart.cartData ? state.cart.cartData.result : null;
  return {
    savedPrescription: state.success.savedPrescription,
    powersDetail: state.success.powersDetail,
    powerSubmittedItemId: state.success.powerSubmittedItemId,
    errorMsg: state.success.errorMsg,
    showRefDD: state.success.showRefDD,
    enterData: state.success.enterData,
    powerSubmitFail: state.success.powerSubmitFail,
    loading: state.success.loading,
    powerSubmitted: state.success.powerSubmitted,
    loginStatus: state.common.login,
    localeInfo: state.common.localeInfo,
    dataLocale: state.locale,
    cartData,
    redisCommonData: state.common.redisCommonData,
    userInfo: state.common.userInfo?.result,
  };
};
function mapDispatchToProps(dispatch) {
  return {
    getOrders: (pageName, size) => dispatch(getOrders(pageName, size)),
    clearState: data => dispatch(clearState(data)),
    successApiCall: bindActionCreators(successApiCall, dispatch),
    getOrder: data => dispatch(getOrder(data)),
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePower);
